var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Social_Icon",
    "data-name": "Social Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Social_Icon-2",
    "data-name": "Social Icon",
    d: "M17.656,14.224a3.362,3.362,0,1,0-3.362-3.362A3.348,3.348,0,0,0,17.656,14.224Zm-8.311,0a3.362,3.362,0,1,0-3.362-3.362A3.348,3.348,0,0,0,9.344,14.224Zm0,2.241c-2.611,0-7.844,1.311-7.844,3.922v2.8H17.189v-2.8C17.189,17.776,11.955,16.465,9.344,16.465Zm8.311,0c-.325,0-.695.022-1.087.056a4.729,4.729,0,0,1,2.208,3.866v2.8H25.5v-2.8C25.5,17.776,20.267,16.465,17.656,16.465Z",
    transform: "translate(2.5 0.5)",
    fill: "#5197ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/socialIcon.1b7fc48530e979fd62e14459de3ba483.svg";
export { ForwardRef as ReactComponent };